module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/zh-hant/1-b191fc957949f0b7ad8af09fa5ee685c.jpg";